import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { ProjectForm } from './ProjectForm';
import { ProjectList } from './ProjectList';
//import ProjectDashboard from './ProjectDashboard';
import AboutSection from '../AboutSection';
import ProjectDashboard from './ProjectDashboard';
import ProjectKpiDashboard from './ProjectKpiDashboard';
//import ProjectBulkUpload from './ProjectBulkUpload';

const isAdmin = true;

const ProjectFormWrapper: React.FC = () => {
  const location = useLocation();
  const pathname = location.pathname;

  let mode: 'create' | 'edit' | 'view' = 'view';
  if (pathname.endsWith('/create')) mode = 'create';
  else if (pathname.endsWith('/edit')) mode = 'edit';

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col w-full p-2">
      <AboutSection title={`Projects - ${mode}`} iconName="folder" />
      <ProjectForm mode={mode} />
    </div>
  );
};

const ProjectsModule: React.FC = () => {
  if (!isAdmin) return <Navigate to="/unauthorized" />;

  return (
    <Routes>
      <Route index element={<ProjectKpiDashboard />} />
      <Route path="list" element={<ProjectList />} />
      <Route path="create" element={<ProjectFormWrapper />} />
      <Route path=":id" element={<ProjectFormWrapper />} />
      <Route path=":id/edit" element={<ProjectFormWrapper />} />
      {/* <Route path="bulk-upload" element={<ProjectBulkUpload />} /> */}
    </Routes>
  );
};

export default ProjectsModule;